import { render, staticRenderFns } from "./softwarePayAliPay.vue?vue&type=template&id=9db49fee&scoped=true&"
import script from "./softwarePayAliPay.vue?vue&type=script&lang=js&"
export * from "./softwarePayAliPay.vue?vue&type=script&lang=js&"
import style0 from "./softwarePayAliPay.vue?vue&type=style&index=0&id=9db49fee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9db49fee",
  null
  
)

component.options.__file = "softwarePayAliPay.vue"
export default component.exports